import { Field } from 'react-final-form';
import { CDN_STATIC_ASSETS } from 'utils';
import { handleErrorMessage } from 'helpers/forms';
import { composeValidators, required } from 'helpers/InputValidators';
import * as Styled from 'components/HubPages/components/GreenlightHistoryCheck/GreenlightRegistrationLookup.styled';

function GreenlightRegistrationLookupFields() {
  return (
    <Styled.Container>
      <Field<string>
        name="registration"
        validate={composeValidators(required('Registration Required'))}
      >
        {({ input, meta }) => (
          <Styled.InputWithIcon
            icon={`${CDN_STATIC_ASSETS}/images/illustrations/eu-symbol-v2.svg`}
            label={'Registration Number'}
            name={input.name}
            onChange={input.onChange}
            placeholder={'e.g 191WX1234'}
            data-testid="registration-input"
            value={input.value}
            willUseSubText={false}
            willUseButton={false}
            errorMessage={handleErrorMessage(meta)}
            disableEnter={true}
          />
        )}
      </Field>
    </Styled.Container>
  );
}

export { GreenlightRegistrationLookupFields };
